import { inject, Injectable, NgZone, signal } from '@angular/core';

export interface ModalOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variante: 'dialog' | 'editor';
  component?: any;
  type?: 'danger' | 'warning' | 'success' | 'info';
  onConfirm?: () => void;
  onCancel?: () => void;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
  activeModal = signal<ModalOptions | null>(null);
  private zone = inject(NgZone);

  constructor() {
    // NUR ZUM TESTEN: Macht den Service in der Konsole verfügbar
    (window as any).testModal = (type: any = 'danger') => {
      this.open({
        title: 'Wirklich löschen?',
        variante: 'dialog',
        message: 'Sieht das Design so gut aus auch wenn der Text länger is als erwartet?',
        type: type,
        onConfirm: () => {},
        onCancel: () => {},
      });
    };
  }

  open(options: ModalOptions) {
    this.activeModal.set(options);
  }

  close(runCancel = true) {
    const current = this.activeModal();

    if (runCancel && current?.onCancel) {
      this.zone.run(() => {
        current.onCancel?.();
      });
    }

    this.activeModal.set(null);
  }

  confirm() {
    const current = this.activeModal();
    if (current && current.onConfirm) {
      // Wir führen die Aktion innerhalb der Angular-Zone aus
      this.zone.run(() => {
        current.onConfirm?.();
      });
    }
    this.close(false);
  }
}
